import {CustomerMessageCallOutcome} from '@dms/api/core';

/** Outcomes where the customer and a user never spoke. */
export const isMissedTelephonyCallOutcome = (outcome: CustomerMessageCallOutcome) =>
  outcome === 'nobody_answered' ||
  outcome === 'caller_hung_up' ||
  outcome === 'customer_not_reached';
